import * as React from 'react';
import { useSelector } from 'react-redux';
import { ReduxState } from '../utils/interface';

const baseUrl = process.env.REACT_APP_PORTAL_V2_URL;

type Props = {
  callbackUrl?: string;
  apiPath?: string;
};

export default function useTokenizedLink({
  callbackUrl = '/device-manager',
  apiPath = '/api/auth/token',
}: Props) {
  const { user, bearerToken } = useSelector((state: ReduxState) => state.auth);

  const url = `${baseUrl}${apiPath}?accessToken=${bearerToken}&username=${user}&callbackUrl=${callbackUrl}`;

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (bearerToken && user) {
      window.location.href = url;
    }
  };

  return {
    url,
    handleClick,
  };
}
